import axios from "axios";

const API = "https://vortexnetowrknew.co.uk/php-backend"; // change if needed

export const getDashboardStats = (data) => axios.post(`${API}/test.php`, data);
